<template>
<div class="page page_history">
    <!-- 时间 -->
    <div class="riqi_wrap" @click="show=true">
        <van-field v-model="riqiMonth" calss="riqi" readonly />
    </div>
    <div class="rili_wrap">
        <ul class="rili_top">
            <li class="week_title">日</li>
            <li class="week_title">一</li>
            <li class="week_title">二</li>
            <li class="week_title">三</li>
            <li class="week_title">四</li>
            <li class="week_title">五</li>
            <li class="week_title">六</li>
        </ul>
        <van-swipe :loop="false" ref="swipeRiLi">
            <van-swipe-item v-for="(item,index) in dayList" :key="index">
                <ul class="rili">
                    <li class="week" v-for="(day,index) in item" :key="index">
						<!-- 没加农历 -->
                        <!-- <div :class="day.status ? 'week_day active' : 'week_day'" @click="clickDate(day)">{{day.date}}</div> -->
						<!-- 加上农历 -->
						<div :class="day.status ? 'week_day active' : 'week_day'" @click="clickDate(day)">
							<span class="">{{day.date}}</span>
							<span class="nongli">{{day.nongli}}</span>
						</div>
                    </li>
                </ul>
            </van-swipe-item>
        </van-swipe>
    </div>
    <!-- 历史经历 -->
    <div class="list">
        <div class="list_title">历史上的今天</div>
        <van-tabs v-model="active" @change="changeTab" swipe-threshold="6">
            <van-tab :name="cate.id" v-for="(cate,index) in cateList" :key="index">
                <template #title> {{cate.title}} </template>
            </van-tab>
        </van-tabs>
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" :immediate-check="false" @load="getData">
            <div class="list_nr">
                <div class="nr_item" v-for="(item,index) in dataList" :key="index">
                    <div :class="item.bc ? 'nr_item_l bc' : 'nr_item_l'">
                        <div class="icon_wrap">
                            <img :src="publicPath+'statics/images/jiangren/active.png'" alt="" class="tu">
                        </div>
                        <div class="time">
                            <div class="year">{{ item.year }}</div>
                            <div class="date">{{ item.day }}</div>
                        </div>
                    </div>
                    <div :class="item.bc ? 'title slh_s bc': 'title slh_s'" @click="toHisoryDetail(item)">{{item.title}}</div>
                </div>
            </div>
        </van-list>
    </div>
	<!-- 书写记忆让爱漂流 -->
	<div class="piaoliu_wrap" @click="goAdriftList">
		<!-- <div class="piaoliu">书写记忆让爱漂流</div> -->
		<img class="piaoliu_bottom" :src="publicPath+'statics/images/piaoliu_bottom.png'" alt="">
	</div>
	
    <!-- 年月日弹层 -->
    <van-popup v-model="show" position="bottom">
        <van-datetime-picker v-model="currentDate" :formatter="formatter" type="year-month" title="选择月份" :max-date="maxDate" @cancel="show = false" @confirm="confirmDate" />
    </van-popup>

</div>
</template>

<script>
import router from '../../../.././router'
import {
    LOGOUT,
    LOGIN
} from '../../../.././vuex/mutation_types'
import Vue from "vue";
import Bridge from "../../../.././vuex/bridge.js";
Vue.prototype.$bridge = Bridge;
var userAgent = navigator.userAgent;

export default {
    name: 'tohistory-index',
    data() {
        return {
            publicPath: process.env.BASE_URL,
            token: '',
            active: -1,
			riqi: this.formatDate(new Date()).year + '年' + this.formatDate(new Date()).month + '月',
			riqiMonth: this.formatDate(new Date()).month + '月',
            show: false,
            currentDate: new Date(),
            year: this.formatDate(new Date()).year, // 年
            month: this.formatDate(new Date()).month, // 月
            day: null, // 日
            dayList: null,
            minDate: new Date('1949/10/1'), // 写法 1949/10/1 ,ios不支持1949-10-1
            maxDate: new Date(new Date().getFullYear()+'/12/31'), // 当前最后一天
            cateList: [], // 分类列表
            dataList: [], // 列表数据
            pages: {
                page: 1,
                size: 10
			},
			loading: true, // 设置了immediate-check 为false , loading需设置为true才能分页
            goNext: false,
			finished: false
        }
    },
    created: function () {
        //根据userAgent判断是否在iOSAndroid客户端中，隐藏原生导航栏
        var that = this
        if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
            var params = {
                data: {
                    'naviTitle': '历史记忆',
                    'rightStyle': 'share'
                }
            };
            this.$bridge.callhandler("sdjy://navigation/style", params, (data) => {});
            //获取用户信息
            var memberParams = {
                data: {
                    notCallLogin: 1,
                },
            };
            this.$bridge.callhandler("sdjy://member/memberInfo", memberParams,
                (data) => {
                    if (data.code == 200) {
                        this.token = data.result.token;
                    } else {
                        this.token = "";
                    }
                }
            );
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler(
                "sdjy://common/refreshPage",
                (data, responseCallback) => {
                    // alert(JSON.stringify(data));
                    responseCallback('');
                }
            );
            
        } else {
            this.token = this.$store.getters.token;

        }
    },
    mounted: function () {
        var that = this
        if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
            var params = {
                data: {
                    'naviTitle': '历史记忆',
                    'rightStyle': 'share'
                }
            };
            this.$bridge.callhandler("sdjy://navigation/style", params, (data) => {});
            //获取用户信息
            var memberParams = {
                data: {
                    notCallLogin: 1,
                },
            };
            this.$bridge.callhandler("sdjy://member/memberInfo", memberParams,
                (data) => {
                    if (data.code == 200) {
                        this.token = data.result.token;
                    } else {
                        this.token = "";
                    }
                    this.setCalendar(this.year, this.month, 1)
                    this.getCateList()
                    this.getData()
                }
            );
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler(
                "sdjy://common/refreshPage",
                (data, responseCallback) => {
                    // alert(JSON.stringify(data));
                    responseCallback('');
                }
            );
            //注册方法，右侧点击分享
            this.$bridge.registerhandler('sdjy://common/rightButtonAction', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                console.log('sdjy://common/rightButtonAction')
                const url = location.href.split('#')[0];
                var params = {
                    data: {
                        title: '历史记忆',
                        detail: '让我们循着历史的脉络，触摸那些不能忘却的历史片段\n一起看看历史上的今天发生了哪些大事件！',
                        url: url,
                        platFormType:'',
                        image: that.$publicData.shareImgPath + 'lishijiyi.jpg'
                    },
                };
                this.$bridge.callhandler('sdjy://public/share', params, (data) => {

                })

            })
        } else {
            this.token = this.$store.getters.token;
            this.getShareData()
        }
    },
    activated() {
		console.log('activated')
		if (this.goNext) {
			this.goNext = false
		} else {
			this.token = this.$store.getters.token
			this.setCalendar(this.year, this.month, 1)
            this.getCateList()
            this.getData()
		}
	},
    methods: {
		// 改变datetime-picker的年月显示, 由年月,转换为月,隐藏'年'这一列
		formatter(type, val){
			if (type === 'year') {
				return `${val}年`;
			} else if (type === 'month') {
				return `${val}月`;
			}
			return val;
		},
		// 详情
        toHisoryDetail(item) {
            if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
                var url = ''
                if(item.web_url){
                    url = item.web_url
                }else{
                    url = this.$publicData.clientUrl + "/tohistory/detail?history_id="+item.history_id
                }
                var memberParams = {
                    data: {
                    },
                };
                this.$bridge.callhandler("sdjy://member/memberInfo", memberParams,
                    (data) => {
                        if (data.code == 200) {
                            var params = {
                                data: {
                                    url: url
                                },
                            };
                            this.$bridge.callhandler(
                                "sdjy://public/openNewWebView",
                                params,
                                (data) => {}
                            );
                        } 
                    }
                );
                
            } else {
                if(item.web_url){
                    window.location.href = item.web_url
                }else{
                    this.goNext = true
                    this.$router.push({
                        path: '/tohistory/detail',
                        query: {
                            history_id: item.history_id
                        }
                    })
                }
			}
			console.log('year','month','day',this.year,this.month,this.day)
			var focusDateObj = {
				year: this.year,
				month: this.month,
				day: this.day
			}
			localStorage.setItem('focusDateObj',JSON.stringify(focusDateObj))
			
        },
        // 拿到某年某月 例如2020年6月
        // 该月 有几周  例如 2020年6月 共4周+2天  算5周 (第一天 和 最后一天)
        // 每一周的日期按 日 - 一 - 二 - 三 - 四 - 五 - 六 排列
        setCalendar(year, month, init) {
            var arr = new Array()
            var newArr = new Array()
            var date = new Date(year, parseInt(month) - 1, '01'); // 该月第一天 5月1号
            date.setMonth(date.getMonth() + 1) // 该月下一个月的第一天 6月1号
            var cdate = new Date(date.getTime() - 1000 * 60 * 60 * 24) // 该月最后一天 5月31号
            var finalDay = cdate.getDate()
            // 组装数组
            for (var i = 1; i <= finalDay; i++) {
                var item = {
					year: year,
					month: parseInt(month),
                    date: i,
					status: 0,
				}
				// 调用农历计算方法 lunarCalendar , 方法定义在com.js 里了,调用的时候不用加this
				var nongli = lunarCalendar(item.year,item.month,item.date)
				// 初一, 直接显示月份, 当月份如果遇上闰月, 显示闰某月 ; 例如 2020年5月23 是 闰四月初一, 显示闰四月
				if(nongli.slice(-2) == '初一'){
					if(nongli.length > 4){
						item.nongli = nongli.slice(0,3)
					}else{
						item.nongli = nongli.slice(0,2)
					}
				}else{
					item.nongli = nongli.slice(-2)
				}
                arr.push(item)
            }
            // 判断第一天是周几，先拿空格补位 补位
            var firstDay = new Date(year, parseInt(month) - 1, '01')
            if (firstDay.getDay() != 0) {
                var firstWeek = firstDay.getDay()
                for (var k = 0; k < firstWeek; k++) {
                    arr.unshift({
						year: year,
						month: month,
                        date: '',
						stauts: 0,
                    })
                }
            }
            // console.log(arr)
            for (var j = 0; j < arr.length; j += 7) {

                newArr.push(arr.slice(j, j + 7))
            }
            console.log('newArr',newArr)
			this.dayList = newArr
            this.setDefaultDay(init)
        },
        // 日期轮播位置跟当前日期关联 -- 默认显示当前这一天
        setDefaultDay(init) {
            // console.log('init', init)
			var list = this.dayList
            var date = new Date()
            var year = date.getFullYear()
            var month = date.getMonth()
            var day = date.getDate()
			var today = new Date(year, month, day, '00', '00', '00')
			// 缓存日期
			if(localStorage.getItem('focusDateObj')){
				var focusDateObj = JSON.parse(localStorage.getItem('focusDateObj'))
				today = new Date(focusDateObj.year,parseInt(focusDateObj.month)-1,focusDateObj.day,'00','00','00')
				this.year = focusDateObj.year
				this.month = focusDateObj.month
				localStorage.removeItem('focusDateObj')
			}
            console.log('today',today)
            // console.log(this.year,parseInt(this.month))
            // console.log('2222',this.$refs.swipeRiLi)
            for (var i = 0; i < list.length; i++) {
                for (var j = 0; j < list[i].length; j++) {
                    if (list[i][j].date && init) {
						// 初始时,选中当天
                        var day = new Date(this.year, parseInt(this.month) - 1, list[i][j].date)
                        // console.log('day',day)
                        if (day.getTime() == today.getTime()) {
                            this.day = (today.getDate()).toString().length != 1 ? today.getDate() : '0' + today.getDate()
                            console.log('today', this.day)
                            list[i][j].status = 1
                            this.$refs.swipeRiLi.swipeTo(i,{
								immediate: true // 跳过动画
							})
                            return
                        }
                    } else if (!init) {
						// 选择月份时，默认选中当月第一天 如 7月1号
						var day = new Date(this.year, parseInt(this.month) - 1, 1)
						this.day = (day.getDate()).toString().length != 1 ? day.getDate() : '0' + day.getDate()
						// console.log('this.day',this.day)
						this.$refs.swipeRiLi.swipeTo(0)
						if(this.day == list[i][j].date){
							list[i][j].status = 1
							this.pages.page = 1
							this.dataList = []
							this.getData()
							return
						}
                    }
                }
            }
        },
        // 点击日期
        clickDate(day) {
			console.log('day', day)
			// 补位日期 现在用的空 所以return掉
			if(day.date == ''){
				return
			}
			// 正常日期
            for (var i in this.dayList) {
                for (var j in this.dayList[i]) {
                    if (day.date == this.dayList[i][j].date) {
                        this.dayList[i][j].status = 1
                        this.day = (day.date).toString().length == 1 ? '0' + day.date : day.date
                    } else {
                        this.dayList[i][j].status = 0
                    }
                }
			}
			this.pages.page = 1
			this.dataList = []
            this.getData()
        },
        // 选择日期 -- 年月
        confirmDate(val, init) {
            console.log(val)
			this.riqi = this.formatDate(val).year + '年' + this.formatDate(val).month + '月'
			this.riqiMonth = this.formatDate(val).month + '月'
            this.formatDate(val)
            // console.log(this.year)
            // console.log(this.month)
            this.setCalendar(this.year, this.month, 0)
        },
        // 转换格式
        formatDate(date) {
            var year = date.getFullYear();
            var month = (date.getMonth() + 1).toString();
            if (month.length == 1) {
                month = '0' + month;
            }
            var obj = {
                year: year,
                month: month
            }
            this.year = year
            this.month = month
            this.show = false
            return obj;
        },
        // 获取分类
        getCateList: function () {
            var params = {
                token: this.token
            }
            this.$api.history.cateList(params).then(res => {
                if (res.code == 200) {
                    this.cateList = res.result
                    var obj = {
                        title: '全部',
                        id: -1
                    }
                    this.cateList.unshift(obj)
                }
            })
        },
        // 获取列表数据
        getData() {
            var params = {
                token: this.token,
                page: this.pages.page,
                size: this.pages.size
			}
            if (this.year && this.month && this.day) {
				console.log(this.year + '-' + this.month + '-' + this.day)
				// params.time = this.year + '-' + this.month + '-' + this.day
				 params.time = this.month + '-' + this.day
            }
            if (this.active != -1) {
                params.cate_id = this.active
            }

            console.log('params', params)
            this.$api.history.hisotryList(params).then(res => {
                if (res.code == 200) {
					var list = res.result.list
					if(list.length != 0){
						for(var i in list){
							var time = list[i].created_at
							var timeArr = time.split(' ')
							var timeInfo = timeArr[0].split('-')
							// console.log(timeInfo)
							if(timeInfo[0] == ''){
								list[i].bc = 1 // 公元前
								list[i].year = '公元前'+timeInfo[1]+'年'
								list[i].day = timeInfo[2] + '月' + timeInfo[3] + '日'
							}else{
								list[i].bc = 0 // 公元纪年
								list[i].year = timeInfo[0]+'年'
								list[i].day = timeInfo[1] + '月' + timeInfo[2] + '日'
							}
							this.dataList.push(list[i])
						}
						this.pages.page++
						this.loading = false
					}else{
						this.finished = true
					}
                }else{
					this.finished = true
				}
            })
		},
		// 切换分类
		changeTab(){
			this.pages.page = 1
			this.dataList = [];
            this.finished = false;
			this.getData()
		},
		// 去漂流列表
		goAdriftList(){
            if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
                var url = this.$publicData.clientUrl + "/adrift/list"
                var params = {
                    data: {
                        url: url
                    },
                };
                this.$bridge.callhandler("sdjy://public/openNewWebView",params,(data) => {

                });
            } else {
                this.goNext = true
                this.$router.push({
                    path: '/adrift/list'
                })
            }
		},
        // 获取分享参数 -- 用于配微信分享
        getShareData() {
            const url = location.href.split('#')[0];
            console.log('url', url)
            this.$api.index.commonShare({
                url: url
            }).then(res => {
                if (res.code == 200) {
                    this.shareConfig = res.result
                    // console.log('this.shareConfig', this.shareConfig)
                    // console.log('this.$route', this.$route)
                    this.shareFun()
                }
            })
        },
        // 分享
        shareFun() {
            var that = this
            wx.config({
                debug: that.shareConfig.debug,
                beta: that.shareConfig.beta,
                jsApiList: that.shareConfig.jsApiList,
                appId: that.shareConfig.appId,
                nonceStr: that.shareConfig.nonceStr, // 随机串
                timestamp: parseInt(that.shareConfig.timestamp), // 时间戳
                signature: that.shareConfig.signature // 签名
            });
            // 分享
            wx.ready(function () {
                const url = location.href.split('#')[0];
                var shareData = {
                    title: '历史记忆', // 分享标题
                    desc: '让我们循着历史的脉络，触摸那些不能忘却的历史片段\n一起看看历史上的今天发生了哪些大事件！', // 分享描述
                    link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: that.$publicData.shareImgPath + 'lishijiyi.jpg', // 分享图标
                    success: function () {
                        // 用户确认分享后执行的回调函数
                        // alert('成功')
                    },
                    cancel: function (e) {
                        // alert(e)
                        // 用户取消分享后执行的回调函数
                    }
                }
                wx.updateAppMessageShareData(shareData);
                wx.updateTimelineShareData(shareData);
            });
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
/deep/.van-hairline--top-bottom::after,
.van-hairline-unset--top-bottom::after {
    border-top: 0 none;
}
/deep/.van-picker__columns .van-picker-column:first-of-type{
	display: none;
}
</style>
